module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('i', [_vm._v("My child, eat honey, for it is good")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("and the drippings of the")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("honeycomb are sweet to")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("your taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Know that wisdom is such to")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("your soul;")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("if you find it, you will find a future,")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("and your hope will not be cut off.")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("—Proverbs 24:13–14")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00311056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/5epigraph.vue
// module id = 75
// module chunks = 0